<script setup>
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import SearchResultSection from './SearchResultSection.vue';
import SearchResultOrderItem from './SearchResultOrderItem.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  orders: { type: Array, default: () => [] },
  query: { type: String, default: '' },
  isFetching: { type: Boolean, default: false },
  showTitle: { type: Boolean, default: true },
});

const router = useRouter();
const { t } = useI18n();

const openOrdersList = query => {
  router.push({
    name: 'web_order_orders',
    query: { q: query, page: '1', status: 'all' },
  });
};
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.ORDERS')"
    :empty="!orders.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
  >
    <ul v-if="orders.length" class="list-none space-y-3">
      <li v-for="order in orders" :key="order.id">
        <SearchResultOrderItem :order="order" />
      </li>
    </ul>
    <NextButton
      v-if="orders.length && query"
      class="mt-3"
      :label="t('SEARCH.VIEW_IN_ORDERS_LIST')"
      icon="i-lucide-list"
      slate
      sm
      outline
      @click="openOrdersList(query)"
    />
  </SearchResultSection>
</template>
